import React, { useCallback, useEffect, useState } from 'react';
import CookieBanner from './CookieBanner';
import CookiePreferencesModal from './CookiePreferencesModal';
import ConsentManager from '../../lib/consentManager';
import consentConfig from '../../config/consentConfig';
import { useAuth } from '../../contexts/AuthContext';
import { syncConsent } from '../../services/consentService';

const CookieConsentRoot = () => {
  const [prefsOpen, setPrefsOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  // Open programmatically if other parts of the app need it
  useEffect(() => {
    window.openCookieSettings = () => setPrefsOpen(true);
    return () => { delete window.openCookieSettings; };
  }, []);

  // Sync to server when updated and user is authenticated
  useEffect(() => {
    const unsubscribe = ConsentManager.onConsentChange(async (consent) => {
      try {
        if (isAuthenticated && consentConfig.serverPersistenceEnabled) {
          await syncConsent(consent);
        }
      } catch (e) {
        // Non-blocking; log for diagnostics only
        console.info('Consent server sync skipped/failed:', e?.response?.status || e?.message);
      }
    });
    return unsubscribe;
  }, [isAuthenticated]);

  const handleOpenCustomize = useCallback(() => setPrefsOpen(true), []);
  const handleClose = useCallback(() => setPrefsOpen(false), []);

  if (!consentConfig.enabled) return null;

  return (
    <>
      <CookieBanner onCustomize={handleOpenCustomize} />
      <CookiePreferencesModal open={prefsOpen} onClose={handleClose} />
    </>
  );
};

export default CookieConsentRoot;
